// ----------------------------------------------------
// Custom Modal Setup (Dynamically Injected)
// ----------------------------------------------------
const customModal = (() => {
    // 1. Create the DOM elements
    const overlay = document.createElement('div');
    overlay.className = 'custom-modal-overlay';
    overlay.innerHTML = `
        <div class="custom-modal-box">
            <div class="custom-modal-message"></div>
            <button class="custom-modal-close">Got it</button>
        </div>
    `;
    document.body.appendChild(overlay);

    // 2. Inject the styles
    const style = document.createElement('style');
    style.textContent = `
        .custom-modal-overlay {
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            backdrop-filter: blur(2px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 999999;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.25s ease;
        }
        .custom-modal-overlay.visible {
            opacity: 1;
            pointer-events: auto;
        }
        .custom-modal-box {
            background: #fff;
            padding: 30px;
            border-radius: 12px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.15);
            max-width: 340px;
            width: 90%;
            text-align: center;
            transform: translateY(15px);
            transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
            font-family: inherit;
        }
        .custom-modal-overlay.visible .custom-modal-box {
            transform: translateY(0);
        }
        .custom-modal-message {
            margin-bottom: 24px;
            font-size: 16px;
            color: #222;
            line-height: 1.4;
            font-weight: 500;
        }
        .custom-modal-close {
            background: rgb(46, 47, 126);
            color: #fff;
            border: none;
            padding: 10px 24px;
            border-radius: 8px;
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            transition: background 0.2s ease;
            width: 100%;
        }
        .custom-modal-close:hover {
            background: #444;
        }
    `;
    document.head.appendChild(style);

    // 3. Bind close event
    overlay.querySelector('.custom-modal-close').addEventListener('click', hide);

    // 4. Exposed methods
    function show(message) {
        overlay.querySelector('.custom-modal-message').textContent = message;
        overlay.classList.add('visible');
    }

    function hide() {
        overlay.classList.remove('visible');
    }

    return { show, hide };
})();


// ----------------------------------------------------
// Message Listener Update
// ----------------------------------------------------
const MAX_SELECTIONS = 8;

window.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SWATCH_UPDATE') {
        const selectedSwatches = event.data.payload;
        updateParentSummaryBar(selectedSwatches);
        
    } else if (event.data && event.data.type === 'form_events_ok') {
        const payload = event.data.payload;
        console.log("Parent received form payload:", payload);

        // Keep the dataLayer push for Google Tag Manager flexibility
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'form_events_ok',
            ...payload
        });

        // Map the payload explicitly to gtag
        if (typeof gtag === 'function') {
            gtag('event', 'conversion', { 
                'send_to': 'AW-662373214/nbB1CMOOxMMcEN6G7LsC',
                
                // --- Standard / User Data Fields ---
                'first_name': payload['First name'] || '',
                'last_name': payload['Last name'] || '',
                'email': payload['Email'] || '',
                'phone_number': payload['Contact Number'] || '',
                
                // --- Address Fields ---
                'address_line_1': payload['Address line 1'] || '',
                'address_line_2': payload['Address line 2'] || '',
                'city': payload['City'] || '',
                'postal_code': payload['Post code'] || '',
                
                // --- Custom Form Selections ---
                'product_interest': payload['Which product are you interested in'] || '',
                'selected_swatches': payload['Selected swatches'] || ''
            });
            console.log("Google Ads conversion event fired with mapped data.");
        } else {
            console.warn("gtag() is not defined on the parent page.");
        }

    } else if (event.data && event.data.type === 'MAX_SELECTIONS_REACHED') {
        customModal.show(event.data.payload.message);
    }
});

// ... Keep your existing updateParentSummaryBar function exactly as is

function updateParentSummaryBar(swatches) {
    const slotsContainer = document.querySelector('.swatch-container');
    
    if (!slotsContainer) {
        console.warn("Swatch container not found on parent page!");
        return;
    }

    slotsContainer.innerHTML = '';

    for (let i = 0; i < MAX_SELECTIONS; i++) {
        const slot = document.createElement('div');
        
        if (i < swatches.length) {
            const swatch = swatches[i];
            
            slot.className = 'swatch-slot filled';
            
            // Apply the image as a background instead of a hex color
            slot.style.backgroundImage = `url('${swatch.imgSrc}')`;
            slot.style.backgroundSize = 'cover';
            slot.style.backgroundPosition = 'center';
            slot.style.backgroundColor = '#eee'; // Fallback background
            
            slot.title = swatch.name || `Selected Swatch ${i + 1}`;
            
            slot.onclick = () => {
                const iframe = document.getElementById('frame_26kGKQtv5_bSFi3MYu9eaQ'); 
                if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.postMessage({
                        type: 'REMOVE_SWATCH',
                        payload: swatch
                    }, '*');
                }
            };
        } else {
            slot.className = 'swatch-slot empty';
            slot.title = `Slot ${i + 1}`;
            
            // Clear out the backgrounds for empty slots
            slot.style.backgroundImage = ''; 
            slot.style.backgroundColor = ''; 
            slot.onclick = null;
        }
        
        slotsContainer.appendChild(slot);
    }
}